import {ActionCreatorHelper} from 'saga-reducer-factory';

const actionsList = [
  'GET_ORGANIZATION_REQUEST',
  'GET_ORGANIZATION_SUCCESS',
  'GET_ORGANIZATION_FAILURE'
];

export const types = ActionCreatorHelper.createTypes(actionsList, 'ORGANIZATION_');
export const actions = ActionCreatorHelper.createActions(actionsList, 'ORGANIZATION_');
export default {types, actions};



// WEBPACK FOOTER //
// ./actions/organizationActions.js